/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
// @ts-expect-error: ts7016
import uritemplate from 'url-template'
// @ts-expect-error: ts7016
import apiGatewayClientFactory from './apiGatewayClient'

export interface MiiaFwApigClient {
  invokeApi: Function
}

export interface MiiaFwApigClientConfig {
  accessKey: string
  secretKey: string
  sessionToken: string
  region: string
  apiKey: string
  invokeUrl: string
  awsEndpoint?: string
  service: string
  defaultContentType: string
  defaultAcceptType: string
  systemClockOffset: number
  headers: { [key: string]: any }
  retries?: number
  retryCondition?: (err: any) => boolean
  retryDelay?: any
  shouldResetTimeout?: boolean
}

interface NormalObj {
  [key: string]: any
}

const removeEmpty = (obj: NormalObj): NormalObj => {
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'object') {
      removeEmpty(obj[key])
    } else if (obj[key] === undefined) {
      delete obj[key]
    }
  })
  return obj
}

export const newClient = (config: Partial<MiiaFwApigClientConfig>): MiiaFwApigClient => {
  config = Object.assign(
    {
      accessKey: '',
      secretKey: '',
      sessionToken: '',
      region: '',
      apiKey: '',
      invokeUrl: '',
      service: 'execute-api',
      defaultContentType: 'application/json',
      defaultAcceptType: 'application/json',
      systemClockOffset: 0,
      headers: {},
      host: undefined
    },
    removeEmpty(config)
  )

  // extract endpoint and path from url
  const invokeUrl = config.invokeUrl
  if (invokeUrl === undefined) {
    throw new Error('invokeUrl must be specified!')
  }

  const matchesOfEndpoint = /(^https?:\/\/[^/]+)/g.exec(invokeUrl)
  if (matchesOfEndpoint == null) {
    throw new Error('invokeUrl is invalid.')
  }
  const endpoint = matchesOfEndpoint[1]
  const pathComponent = invokeUrl.substring(endpoint.length)

  const sigV4ClientConfig = {
    accessKey: config.accessKey,
    secretKey: config.secretKey,
    sessionToken: config.sessionToken,
    serviceName: config.service,
    region: config.region,
    endpoint: endpoint,
    awsEndpoint: config.awsEndpoint,
    defaultContentType: config.defaultContentType,
    defaultAcceptType: config.defaultAcceptType,
    systemClockOffset: config.systemClockOffset,
    retries: config.retries,
    retryCondition: config.retryCondition,
    retryDelay: config.retryDelay
  }

  let authType = 'NONE'
  if (
    sigV4ClientConfig.accessKey !== undefined &&
    sigV4ClientConfig.accessKey !== '' &&
    sigV4ClientConfig.secretKey !== undefined &&
    sigV4ClientConfig.secretKey !== ''
  ) {
    authType = 'AWS_IAM'
  }

  const simpleHttpClientConfig = {
    endpoint: endpoint,
    defaultContentType: config.defaultContentType,
    defaultAcceptType: config.defaultAcceptType,
    retries: config.retries,
    retryCondition: config.retryCondition,
    retryDelay: config.retryDelay,
    headers: config.headers
  }

  const apiGatewayClient = apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig)

  const invokeApi = (params: object, pathTemplate: string, method: string, additionalParams: any, body?: any): any => {
    if (additionalParams === undefined) additionalParams = {}
    if (body === undefined) body = ''

    const request = {
      verb: method.toUpperCase(),

      path: pathComponent + uritemplate.parse(pathTemplate).expand(params),
      headers: additionalParams.headers || {},
      timeout: additionalParams.timeout || 0,
      queryParams: additionalParams.queryParams,
      body: body
    }

    return apiGatewayClient.makeRequest(request, authType, additionalParams, config.apiKey)
  }

  return { invokeApi }
}

export default { newClient }
